import { Mutation, VuexModule } from "vuex-class-modules"

import { $t } from "@/plugins/i18n"
import setError from "@/store/helpers/error"
import { AlertActions, alertModule } from "@/store/modules/alert.module"

import { AlertContentItem, AlertType } from "./Alert"
import { HttpError } from "./Error"

export class BaseModule extends VuexModule {
  error: Error | null

  @Mutation
  setError(error: Error | null) {
    this.error = error
  }

  protected handleResponse<T>(
    data: T | HttpError,
    success?: (data: T) => void | any,
    noErrorAlert?: boolean | ((data: HttpError) => boolean),
    reject?: (data: HttpError) => any | void,
    responseRequired?: boolean
  ): boolean | any {
    if (!(data instanceof HttpError)) {
      if (success && typeof success === "function") {
        const response = success(data)
        if (responseRequired) return response
        return response || true
      }
      return true
    } else {
      this.reject(data, noErrorAlert)
      if (reject && typeof reject === "function") {
        return reject(data)
      }
      return false
    }
  }

  protected reject(data: HttpError, noAlert?: boolean | ((data: HttpError) => boolean)) {
    if (data.noErrorAlert || !data.message) return
    const error = setError(data)
    this.setError(error)

    if (!noAlert || (typeof noAlert === "function" && !noAlert(data))) {
      const alertContent: AlertContentItem[] = [
        { text: `${$t("alert.error", [error.message])}`, type: "regular" }
      ]
      alertModule[AlertActions.SHOW_ERROR_ALERT]({
        contentTitle: [],
        theme: "global",
        type: AlertType.ERROR,
        content: alertContent,
        alertRespDetail: {
          message: data.response.data.message,
          requestUrl: data.response?.config?.url,
          responseStatus: data.response?.status,
          traceId: data.response?.headers?.["x-trace-id"]
        }
      })
    }
  }
}
